import couponApi from "@/service/modules/couponApi";
import { CheckCircleOutlined, CloseOutlined, LeftOutlined, RightOutlined } from "@ant-design/icons";
import { Modal, Image, message, Button } from "antd";
import Link from 'next/link'
import { useEffect, useState } from "react";
import styles from '@/styles/addToCartSuccessModal.module.scss'
import { Swiper, SwiperSlide } from 'swiper/react';
import { useSelector } from 'react-redux';
import { RootState } from '@/store/store';
import viewcartApi from "@/service/modules/viewcartApi";
import ViewcarGoodsComponent from "./ViewcarGoodsComponent";

export default function AddToCartSuccessModal({ showAddToCartModal, setShowAddToCartModal }: { showAddToCartModal: boolean, setShowAddToCartModal: Function }) {
  return (
    <Modal open={showAddToCartModal} onCancel={() => { setShowAddToCartModal(false) }} modalRender={() => <ModalRender setIsModalOpen={setShowAddToCartModal} />} width="696px" />
  )
}

function ModalRender({ setIsModalOpen }: any) {

  const [swiper, setSwiper]: any = useState(null);
  const available = useSelector((state: RootState) => state.cartListSlice.data.available);
  const subtotal = useSelector((state: RootState) => state.cartListSlice.data.subtotal);
  const count = useSelector((state: RootState) => state.cartListSlice.data.count);
  const [recommendList, setRecommendList] = useState([])
  const [isBeginning, setIsBeginning] = useState(true); // 默认开始在第一屏
  const [isEnd, setIsEnd] = useState(false);            // 默认不在最后一屏
  useEffect(() => {
    if (available.length > 0) {
      getRecommendList(available)
    }
  }, [available])

  const getRecommendList = async (list: any) => {
    try {
      const params = list.map((item: any) => ({ productID: item.productID, categoryID: item.categoryID }))
      const res = await viewcartApi.related({ items: params })
      const { pageList } = res.data
      if (pageList) {
        const { items } = pageList
        setRecommendList(items)
      }
    } catch (error: any) {
      console.log(error);
    }
  }

  const slidePrev = () => {
    swiper.slidePrev()
  }

  const slideNext = () => {
    swiper.slideNext()
  }

  // 更新购物车列表
  const successAddCart = (res: any) => {
    console.log(res)
  }
  return (
    <div className={styles['addToCartSuccessModal']} style={{ pointerEvents: 'auto' }}>
      <div className={styles['goodsInfo']}>
        <div className={styles['goodsInfo-left']}>
          <div className={styles['goodsImg']}>
            <Image src={available[0].defaultFullUrl} width={'100%'} />
          </div>
        </div>
        <div className={styles['goodsInfo-right']}>
          <div className={styles['successTips']}>
            <CheckCircleOutlined style={{ marginRight: 10, fontSize: 21, color: '#3DBD79' }} />Added to Cart
          </div>
          <div className={styles['totalLine']}>
            {`Cart Total (${count} items): `}<span className={styles['cartTotal']}>${subtotal}</span>
          </div>
          <div className={styles['config']}>
            <Button type="primary" className={styles['config-btn']} href="/checkout">Checkout {count} items</Button>
            <Button type="primary" ghost className={styles['config-btn']} href="/viewcart" >Go to cart</Button>
            <Button type="primary" ghost className={styles['config-btn']} href="/">Continue shopping</Button>
          </div>
        </div>
      </div>

      {
        recommendList.length > 0
        &&
        <div className={styles['recommend-box']}>
          <div className={styles['recommend-title']}>Customer Who Bought These Products Also Bought</div>
          <div className={styles['recommend-list']}>
            <Swiper
              direction="horizontal"
              onSwiper={(swiper) => setSwiper(swiper)}
              slidesPerView={4}
              slidesPerGroup={4}
              spaceBetween={17}
              onSlideChange={(swiper) => {
                // 滑动时更新状态
                setIsBeginning(swiper.isBeginning);
                setIsEnd(swiper.isEnd);
              }}
            >
              {
                recommendList.map((item: any) => (
                  <SwiperSlide key={item.productID}>
                    <ViewcarGoodsComponent {...item} successAddCart={successAddCart} />
                  </SwiperSlide>
                ))
              }

            </Swiper>

            <div className={styles['page-left']}>
              <LeftOutlined onClick={slidePrev} style={{ color: isBeginning ? '#CBCBCB' : '#333333', fontSize: 20 }} />
            </div>

            <div className={styles['page-right']}>
              <RightOutlined onClick={slideNext} style={{ color: isEnd ? '#CBCBCB' : '#333333', fontSize: 20 }} />
            </div>
          </div>
        </div>
      }


      <CloseOutlined onClick={() => { setIsModalOpen(false) }} className={styles['close-icon']} />
    </div>
  )
}